const o = {
  color: {
    background: "#405261ff"
  },
  alpha: "0.72"
};
export {
  o as overlay
};
